import useAuthStore from "../store/authStore";
import { useNavigate } from "react-router-dom";

export const useLogout = () => {
  const navigate = useNavigate();

  const logoutAndRedirect = () => {
    const { logout } = useAuthStore.getState(); // Access logout from Zustand store
    logout(); // Clear user/token and set isLoggingOut
    navigate("/login"); // Redirect to login page
  };

  return logoutAndRedirect;
};
